<template>
  <div>
    <div style="margin-left:325px;">
      <v-img src="/graph" style="width:75%;"></v-img>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TrendChart',

  components: {
  },

  data() {
    return {
    };
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  methods: {
  },
};
</script>
